import script from "./PaymentServiceInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentServiceInfo.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__